/* =========================================================
   RABESSA AYUBI — second-colour offer

   A standalone add-on. It talks to the storefront only through
   what rabessa.js already exposes publicly:
     · the product JSON in [data-product-json]
     · the selected variant on [data-add]'s data-variant attribute
     · window.RabessaCart.add()

   That means this file can be removed at any time and the shop
   keeps working exactly as before — which is the point, because
   the offer depends on a Shopify discount that may be paused.

   It never prints a discounted price. It shows the true saving
   the store's automatic "second piece 40% off" discount will
   apply at checkout, and nothing more.
   ========================================================= */
(function () {
  "use strict";

  var CFG = window.RABESSA || {};
  var RATE = 0.4;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents, currency) {
    var cur = currency || CFG.currency || "USD";
    try {
      return new Intl.NumberFormat(CFG.locale || document.documentElement.lang || "en",
        { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) {
      return cur + " " + (cents / 100).toFixed(2);
    }
  }

  // Price in the buyer's active market. On the storefront Liquid has already
  // rendered cents; in preview mode we read the real presentment-price map.
  function priceCents(v) {
    if (v.prices && CFG.currency && v.prices[CFG.currency] != null) {
      return Math.round(v.prices[CFG.currency] * 100);
    }
    return v.price_cents || 0;
  }

  function add(id, qty, source) {
    if (window.RabessaCart && window.RabessaCart.add) {
      return window.RabessaCart.add(id, qty, { source: source, keepOpen: true });
    }
    return Promise.reject(new Error("Cart unavailable"));
  }

  function toast(msg, tone) {
    if (window.RabessaCart && window.RabessaCart.toast) window.RabessaCart.toast(msg, tone);
  }

  /* ---------- "add these two variants" buttons (homepage band) ---------- */
  function initPairButtons() {
    $$("[data-add-variants]").forEach(function (btn) {
      if (btn.hasAttribute("data-secondbuy-add")) return; // wired separately below
      btn.addEventListener("click", function () {
        run(btn);
      });
    });
  }

  function run(btn) {
    var ids = (btn.getAttribute("data-add-variants") || "").split(",").filter(Boolean);
    if (ids.length < 2) { toast("Both colours need to be in stock for this.", "error"); return; }
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = "Adding…";
    add(ids[0], 1, "colour_pair")
      .then(function () { return add(ids[1], 1, "colour_pair"); })
      .catch(function () { /* rabessa.js already surfaced the error */ })
      .then(function () {
        btn.disabled = false;
        btn.innerHTML = label;
        try {
          document.dispatchEvent(new CustomEvent("rabessa:colour_pair_added", { detail: { variants: ids } }));
          if (window.dataLayer) window.dataLayer.push({ event: "rabessa_colour_pair_added", variants: ids.join(",") });
        } catch (e) {}
      });
  }

  /* ---------- the offer panel on the product page ---------- */
  function initOffer() {
    var panel = $("[data-secondbuy]");
    var form = $("[data-product-form]");
    var addBtn = $("[data-add]", form || document);
    if (!panel || !form || !addBtn) return;

    var data;
    try { data = JSON.parse($("[data-product-json]", form).textContent); } catch (e) { return; }

    var list = $("[data-secondbuy-list]", panel);
    var cta = $("[data-secondbuy-add]", panel);
    var err = $("[data-secondbuy-error]", panel);
    var saveEl = $("[data-secondbuy-save]", panel);
    var pick = null;

    function currentId() { return addBtn.getAttribute("data-variant"); }

    function render() {
      var cur = currentId();
      var others = data.variants.filter(function (v) { return String(v.id) !== String(cur); });
      var buyable = others.filter(function (v) { return v.available; });

      // Never offer a pairing that cannot be bought, and never show the panel
      // at all on a product with only one colour in stock.
      if (!buyable.length) { panel.hidden = true; return; }
      panel.hidden = false;

      if (!pick || String(pick.id) === String(cur) || !pick.available) pick = buyable[0];

      list.innerHTML = others.map(function (v) {
        return '<li><button type="button" class="swatch" role="radio" ' +
          'aria-checked="' + (String(v.id) === String(pick.id) ? "true" : "false") + '" ' +
          'data-available="' + (v.available ? "true" : "false") + '" ' +
          'data-second-variant="' + v.id + '" ' +
          'aria-label="' + v.title + (v.available ? "" : " — sold out") + '">' +
          (v.image ? '<img src="' + v.image + '" alt="" loading="lazy">' : '<span class="swatch__solid"></span>') +
          "</button></li>";
      }).join("");

      $$("[data-second-variant]", list).forEach(function (b) {
        b.addEventListener("click", function () {
          var v = others.filter(function (x) { return String(x.id) === String(b.getAttribute("data-second-variant")); })[0];
          if (!v) return;
          if (!v.available) {
            err.hidden = false;
            err.textContent = v.title + " is sold out. Pick another colour.";
            return;
          }
          err.hidden = true;
          pick = v;
          render();
        });
      });

      cta.setAttribute("data-add-variants", cur + "," + pick.id);

      // Both colours of one product carry the same price, so this saving is
      // exact rather than an estimate.
      if (saveEl) saveEl.textContent = money(Math.round(priceCents(pick) * RATE), CFG.currency);
    }

    cta.addEventListener("click", function () { run(cta); });

    // Follow whatever colour the shopper selects. Watching the attribute
    // rabessa.js maintains keeps the two in step without patching it.
    if ("MutationObserver" in window) {
      new MutationObserver(render).observe(addBtn, { attributes: true, attributeFilter: ["data-variant"] });
    }
    document.addEventListener("rabessa:variant_change", render);

    render();
  }

  function init() { initPairButtons(); initOffer(); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
